'use client';

import { c as _c } from "react/compiler-runtime";
export const DragOverlay = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="fixed inset-0 z-modal-over flex flex-col items-center justify-center gap-3 bg-black/70 backdrop-blur-sm"><div className="flex size-20 items-center justify-center rounded-full bg-primary/30"><svg xmlns="http://www.w3.org/2000/svg" className="size-10 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg></div><p className="text-xl font-semibold text-white">Drop media here</p><p className="text-sm text-white/70">Images, videos, and PDFs supported</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};